import React from 'react'
import VoyahFreeHero from '../../components/pages/VoyahFree/VoyahFreeHero/VoyahFreeHero'
import Warranty from '../../components/pages/VoyahFree/Warranty/Warranty'
import VoyahExteriorInterior from '../../components/pages/VoyahFree/VoyahExteriorInterior/VoyahExteriorInterior'
import VoyahFeatures from '../../components/pages/VoyahFree/VoyahFeatures/VoyahFeatures'
import Footer2 from '../../components/pages/VoyahFree/Footer2'
import BackToVehicleModels from '../../components/BackToVehicleModels/BackToVehicleModels'
import VoyahFreeExtras from '../../components/pages/VoyahFree/VoyahFreeExtras/VoyahFreeExtras'
import VoyahFreeTechnicalSpecs from '../../components/pages/VoyahFree/VoyahFreeTechnicalSpecs/VoyahFreeTechnicalSpecs'

const VoyahFree = () => {
  return (
    <div className='vfpage'>
        <VoyahFreeHero/>
        <VoyahFreeTechnicalSpecs />
        <Warranty/>
        <VoyahExteriorInterior/>
        <VoyahFreeExtras/>
        <VoyahFeatures/>
        <BackToVehicleModels variant="light" />
        <Footer2/>
    </div>
  )
}

export default VoyahFree